import React from 'react';
import { useCheckWarehouseIdInGrayConfig } from '../../../graphql/queries/commonConfigQueries';
import OldBaggingScanPage from '../../dsp/bagging-scan/OldBaggingScanPage';
import OldPdaBagging from '../OldBaggingPage';

/** 装包扫描新版本按仓灰度配置键（与后端 ConfigKey.PDA_BAGGING_SCAN_USE_NEW_PAGE 一致） */
const BAGGING_SCAN_GRAY_CONFIG_KEY = 'pda.bagging.scan.use.new.page';

/**
 * PDA装包扫描页面灰度切换包装组件（按仓灰度）
 * 根据 common_config 的 pda.bagging.scan.use.new.page 判断当前账号绑定仓是否使用新页面
 * 配置值：All 表示全部仓用新版本；逗号分隔的仓库ID表示仅这些仓用新版本；未配置或为空则用旧版本
 */
const OldBaggingScanPageWrapper: React.FC = () => {
    const { data, loading } = useCheckWarehouseIdInGrayConfig(BAGGING_SCAN_GRAY_CONFIG_KEY);

    if (loading) {
        return null;
    }

    const useNewPage = data?.checkWarehouseIdInGrayConfig ?? false;
    return useNewPage ? <OldBaggingScanPage /> : <OldPdaBagging />;
};

export default OldBaggingScanPageWrapper;
